import { AfterViewInit, Component } from '@angular/core';

import { LexTranslateService } from '@app/core/services/lex-translate.service';
import { ModificationGuardService } from '../../../cadastro/admin/services/modification-guard.service';

@Component({
  selector: '[seb-modification-modal]',
  templateUrl: './modification-modal.component.html',
  styleUrls: ['./../modal-warning/modal-warning.component.css']
})
export class ModificationModalComponent implements AfterViewInit {

  title: string
  message: string
  confirmation: string
  customIdLabel: string = "modification-modalLabel"
  toShowModal = false

  constructor(
    private modificationGuardService: ModificationGuardService,
    public lextranslate: LexTranslateService
  ) { }

  async ngAfterViewInit() {
    await this.lextranslate.loadTranslationsInFunctionOfTenant()

    this.title = this.lextranslate.i18n["ba7dd5f5-b8c1-4c4f-96a4-45b05663d293"]
    this.message = this.lextranslate.i18n["d74318ea-d3a2-4a91-a19a-88283ec6f896"] + '.'
    this.confirmation = this.lextranslate.i18n["19f949f0-3850-4156-ba04-aaf3fd2e9952"] + '?'
    this.toShowModal = true
  }

  confirmAction () {
    this.modificationGuardService.confirmation$.next(true)
  }

  cancelAction () {
    this.modificationGuardService.confirmation$.next(false)
  }
}
